import type { AllRouteEndpoints } from "../routeTypes";

export const productAlerts = "/product_alerts";
export const productAlertsId = "/product_alerts/:id";

export const productAlertsIdCacheKeys: AllRouteEndpoints[] = [productAlertsId, productAlerts];
